import { Pipe, PipeTransform } from '@angular/core';

@Pipe( { name: 'lock' } )
export class LockPipe implements PipeTransform {

    transform( pIsApproved: boolean ): string {
        if ( pIsApproved != null ) {
            return pIsApproved === true ? 'Locked' : 'Unlocked';
        }
        return 'Unlocked';
    }
}